import { animate, style, transition, trigger } from '@angular/animations';
import { Component, Inject, Input, OnInit } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { ClientSelectionState } from '../../../../state/ClientSelectionState/ClientSelection.state';
import { InstanceTypes } from '../../../../models/instance-types';
import { AclService } from '../../../../services/acl.service';

@Component({
  selector: 'before-you-begin',
  templateUrl: './before-you-begin.component.html',
  styleUrls: ['./before-you-begin.component.scss'],
  standalone: false
})
export class BeforeYouBeginComponent implements OnInit {
  @Input() unsupported: string[] = [];
  @Input() errors: string[] = [];
  @Input() warnings: string[] = [];

  @Select(ClientSelectionState.clientCode)
  clientCode: Observable<string>;

  canAccessChangeRequests = false;

  get baseUrl() {
    if (this.env.instanceType == InstanceTypes.CsrPortal) {
      return '/client';
    }
    return '';
  }

  constructor(
    @Inject('env') private env: any,
    private aclService: AclService,
    private store: Store
  ) {}

  ngOnInit(): void {
    if (this.env.instanceType == InstanceTypes.ClientPortal) {
      //CLP users need EditPeople or CLP Admin access to view
      //Change Requests
      this.store.selectOnce(ClientSelectionState.clientCode).subscribe(code => {
        this.aclService
          .CurrentUserAccessCheck('Client Portal Admin', 'EditPeople', code)
          .subscribe(result => {
            this.canAccessChangeRequests = result;
          });
      });
    } else if (this.env.instanceType == InstanceTypes.CsrPortal) {
      //CSRs can always access.
      this.canAccessChangeRequests = true;
    }
  }
}
